import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-counterclockwise-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M9 .75v1.269a6.5 6.5 0 1 1-6.507 3.993.5.5 0 0 1 .924.383 5.5 5.5 0 1 0 5.584-3.372L9 4.25a.5.5 0 0 1-.83.376l-2-1.75a.5.5 0 0 1 0-.752l2-1.75A.5.5 0 0 1 9 .75Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
